import { DatePicker } from '../../../components/date-picker/date-picker';
import { DateTime, Interval } from 'luxon';
import { Field, FieldLabel } from '../../../components/field/field';
import { PurchaseAdminSelect } from '../purchase-admin-select';
import { OrderSection } from '../../order/order-section/order-section';
import React from 'react';
import { Admin } from '../../../clients/quipli-service/admin/admin';
import { Typography } from '../../../components/typography/typography';
import classNames from 'classnames';

export const PurchaseOrderDetails = ({
  isEditing = false,
  date,
  setDate,
  poNumber,
  setPoNumber,
  purchasedBy,
  setPurchasedBy,
  className,
  useSignedAdminAsDefault = false,
}: {
  isEditing?: boolean;
  date?: DateTime;
  setDate: (date?: DateTime) => void;
  poNumber?: string;
  setPoNumber?: (poNumber: string) => void;
  purchasedBy?: Admin;
  setPurchasedBy: (admin?: Admin) => void;
  className?: string;
  useSignedAdminAsDefault?: boolean;
}) => {
  return (
    <OrderSection className={classNames(className)} header="Purchase Details">
      <div className="flex flex-col pt-4 gap-4 flex-wrap">
        {isEditing ? (
          <>
            <div className="flex-grow">
              <DatePicker
                isRequired
                inputWrapperClassName="!w-full"
                label="Date"
                value={date}
                onChange={setDate}
                dataCy="order-date"
                disabledIntervals={[
                  Interval.fromDateTimes(DateTime.local().plus({ days: 1 }), DateTime.local().plus({ year: 1000 })),
                ]}
              />
            </div>

            {setPoNumber && (
              <Field type="text" value={poNumber} onChange={(value) => setPoNumber(value)} label="PO Number" />
            )}

            <PurchaseAdminSelect
              admin={purchasedBy}
              setAdmin={setPurchasedBy}
              useSignedAdminAsDefault={useSignedAdminAsDefault}
            />
          </>
        ) : (
          <>
            <DetailRow label="Date" value={date?.toFormat('LLL-dd y')} />
            <DetailRow label="PO Number" value={poNumber} />
            <DetailRow label="Purchased By" value={purchasedBy?.adminFullName} />
          </>
        )}
      </div>
    </OrderSection>
  );
};

const DetailRow = ({ label, value }: { label: string; value?: string }) => {
  return (
    <div className="flex justify-between items-center">
      <FieldLabel label={label} />
      <Typography type="text-sm" weight="medium" className="text-quipli-black-700">
        {value || 'N/A'}
      </Typography>
    </div>
  );
};
